export const IncomePageOptions = [
  {
    label: 'Summary',
    value: 'summary'
  },
  {
    label: 'Account',
    value: 'account'
  }
]
export const PROJECTED_CURRENT_YEAR = '1'
export const PROJECTED_NEXT_12_MONTHS = '2'

export const IncomeYearoptions = [
  {
    label: 'Current Year',
    value: PROJECTED_CURRENT_YEAR
  },
  {
    label: 'Next 12 Months',
    value: PROJECTED_NEXT_12_MONTHS
  }
]

export const IncomeCategories = [
  { name: 'Interest purchased/sold', color: 'chartIndicatorVerdigris', key: 'interestPurchasedSold' },
  { name: 'Interest Received', color: 'chartIndicatorDarkSkyBlue', key: 'interestReceived' },
  { name: 'Dividend', color: 'chartIndicatorBlue', key: 'dividend' },
  { name: 'Principal', color: 'chartIndicatorTeal', key: 'principal' },
  { name: 'Option Premiums Paid', color: 'chartIndicatorVibrant', key: 'optionPremiumPaid' },
  { name: 'Option Premiums Received', color: 'chartIndicatorTeal2', key: 'optionPremiumReceived' },
  { name: 'Interest', color: 'chartIndicatorGreenThumb', key: 'interest' },
  { name: 'Capital Gains Distribution', color: 'chartIndicatorLightBlue', key: 'capGain' }
]

export const OptionsPremiumsWidget = ['totalOptionPremiums']
export const OptionsPremiums = ['optionPremiumPaid', 'optionPremiumReceived']
export const IncomeShowTaxableAccountsValue = 'IncomeShowTaxableAccounts'
